/** Only transport/capacity errors allow displaying a recent, already validated read. */
export function isTemporaryHqReadFailure(error: unknown): boolean {
  const code = error && typeof error === 'object' && 'code' in error ? String(error.code) : '';
  return [
    'functions/internal',
    'functions/unavailable',
    'functions/resource-exhausted',
    'functions/deadline-exceeded',
    'functions/network-request-failed',
  ].includes(code);
}

/** For private-media reads that do not pass through callable admission. Never use for saves. */
export async function retryTemporaryHqRead<T>(
  read: () => Promise<T>,
  isCurrent: () => boolean,
): Promise<T> {
  for (let attempt = 0; ; attempt++) {
    if (!isCurrent()) throw Error('MEDIA_SESSION_CHANGED');
    try {
      const value = await read();
      if (!isCurrent()) throw Error('MEDIA_SESSION_CHANGED');
      return value;
    } catch (error) {
      if (!isCurrent()) throw Error('MEDIA_SESSION_CHANGED');
      const delay = [500, 1500][attempt];
      if (!isTemporaryHqReadFailure(error) || delay === undefined) throw error;
      await new Promise((resolve) => setTimeout(resolve, delay));
    }
  }
}
